<template>
  <div id="kt_header" ref="kt_header" class="header header-fixed" :class="headerClasses">
    <div class="d-flex align-items-center" :class="{ 'container-fluid': widthFluid, container: !widthFluid }">
      <button
        v-if="!isPublicApp && headerMenuEnabled"
        class="d-flex align-items-center btn btn-icon aside-toggle ml-n3 mr-10"
        id="kt_aside_desktop_toggle"
        ref="kt_aside_desktop_toggle"
        data-test="aside-toggle"
        @click="toggleAside()"
      >
        <span class="svg-icon svg-icon-xxl svg-icon-dark-75">
          <inline-svg src="/media/svg/icons/Text/Align-left.svg" />
        </span>
      </button>

      <BackToClientWebsiteLink v-if="displayBackToClientWebsiteLink" class="w-100" />

      <!-- Client logo -->
      <div class="header-logo">
        <router-link to="/">
          <img
            alt="Logo"
            :src="getOrganizationLogo()"
            class="logo-sticky max-h-50px max-w-250px"
            data-test="header-logo-organization"
          />
        </router-link>
      </div>

      <Topbar />
    </div>

    <Aside v-if="asideEnabled" />
    <div class="aside-overlay" v-if="isOnAside" @click="closeAside"></div>
  </div>
</template>

<script setup>
/* eslint no-unused-vars:off */
import { computed, inject } from "vue";
import { layoutService } from "@/core/services/layout.service";
import { storeToRefs } from "pinia";
import { useClassesStore } from "@/core/store/config/classesStore";
import { useContainerLayout } from "@/core/composables/containerLayout";
import { useLayoutConfigStore } from "@/core/store/config/configStore";
import Aside from "@/view/layout/aside/Aside.vue";
import BackToClientWebsiteLink from "@/view/layout/header/BackToClientWebsiteLink.vue";
import Topbar from "@/view/layout/header/Topbar.vue";
import useLayoutStore from "@/core/store/layout/layoutStore";

const isPublicApp = inject("isPublicApp");
const { getClasses } = useClassesStore();
const { getLayoutConfig } = useLayoutConfigStore();

const { displayBackToClientWebsiteLink } = useContainerLayout();
const layoutStore = useLayoutStore();

const { isOnAside } = storeToRefs(layoutStore);
const { toggleAside, closeAside } = layoutStore;

const asideEnabled = computed(() => !!getLayoutConfig("aside.self.display"));
const headerMenuEnabled = computed(() => !!getLayoutConfig("header.menu.self.display"));

const headerClasses = computed(() => {
  const classes = getClasses("header");
  return classes ? classes.join(" ") : null;
});

const widthFluid = computed(() => getLayoutConfig("header.self.width") === "fluid");

const getOrganizationLogo = () => layoutService.getOrganizationLogo();
</script>
